import {
    Component,
    ElementRef,
    ChangeDetectionStrategy,
    ViewEncapsulation
} from '@angular/core';

/**
 * Button Group Component
 * See storybook for examples.
 *
 * @example
 * <ihd-button-group>
 *      <button ihdButton>
 *          <span>Button Example</span>
 *      </button>
 * </ihd-button-group>
 *
 * @export
 * @class ButtonGroupComponent
 * @implements {OnInit}
 */
@Component({
    selector: 'ihd-button-group',
    templateUrl: './button-group.component.html',
    // styleUrls: ['./button-group.component.scss'], NOTE: Move to global
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'c-btn-group'
    }
})

export class ButtonGroupComponent {
    private nativeElement: HTMLElement;

    constructor(private element: ElementRef) {
        this.nativeElement = element.nativeElement;
    }
}
